import React from 'react';

const ChatListItem = ({ chat, onSelect }) => {
  const utcTimestamp = chat.time + 'Z';
  const date = new Date(utcTimestamp);

  const now = new Date();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const localDate = new Date(
    date.toLocaleString('en-US', { timeZone: userTimeZone }),
  );
  const localNow = new Date(
    now.toLocaleString('en-US', { timeZone: userTimeZone }),
  );

  const isToday = localDate.toDateString() === localNow.toDateString();

  const yesterday = new Date(localNow);
  yesterday.setDate(localNow.getDate() - 1);
  const isYesterday = localDate.toDateString() === yesterday.toDateString();

  let formattedTime;

  if (isToday) {
    formattedTime = localDate.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } else if (isYesterday) {
    formattedTime = 'Yesterday';
  } else {
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    const year = localDate.getFullYear();
    formattedTime = `${month}-${day}-${year}`;
  }

  return (
    <div
      className="flex items-start p-2 rounded-md hover:bg-purple-50 cursor-pointer transition-colors"
      onClick={() => onSelect(chat)}
    >
      <img
        src={chat.avatar}
        alt={chat.name}
        className="w-10 h-10 rounded-full object-cover"
      />
      <div className="flex-1 ml-3 overflow-hidden">
        <div className="flex justify-between items-center">
          <span className="text-sm font-semibold truncate">{chat.name}</span>
          <span className="text-xs text-gray-400">{formattedTime}</span>
        </div>
        <div className="text-sm text-gray-500 truncate">{chat.lastMessage}</div>
      </div>
      {chat.unread > 0 && (
        <div className="ml-2 mt-1 w-5 h-5 bg-purple-500 text-white text-xs rounded-full flex items-center justify-center">
          {chat.unread}
        </div>
      )}
    </div>
  );
};

export default ChatListItem;
